<template>
    <div>
        <div class="notification-bar animated" :class="animate" v-if="message">
            <div class="box ">
                <div class="box-inner">
                    <i class="fa" :class="icon"></i> <strong>{{ message }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Notification from '../../Services/Notification.js';

    export default {
        data() {
            return {
                service: Notification,
                clearing: false
            }
        },
        watch: {
            message() {
                setTimeout(() => {
                    this.clearing = true;
                }, 2000);
                setTimeout(() => {
                    this.service.clear();
                }, 3000);
            }
        },
        computed: {
            message() {
                return this.service.message;
            },
            level() {
                return this.service.level;
            },
            icon() {
                return {
                    'fa-check text-success': this.level == 'success',
                    'fa-info text-info': this.level == 'info',
                    'fa-warn text-warning': this.level == 'warn'
                }
            },
            animate() {
                return {
                    'bounceInUp': this.message && !this.clearing,
                    'bounceOutDown' : this.clearing
                };
            }
        }
    }
</script>

<style scoped lang="scss">


    .notification-bar {
        position:fixed;
        padding:1em 0;
        left:0;
        bottom:0;
        text-align:center;
        width:100%;
        z-index: 99999;
        > div {
            width: 33.33%;
            margin:0 auto;
            -webkit-box-shadow: 0px 2px 10px 0px  rgba(#000000, .2);
            -moz-box-shadow: 0px 2px 10px 0px  rgba(#000000, .2);
            box-shadow: 0px 2px 10px 0px rgba(#000000, .2);
            > div {
                padding:1em 0;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/Notification.vue